import { render, staticRenderFns } from "./jlw.vue?vue&type=template&id=76dddf7a&scoped=true&"
var script = {}
import style0 from "./jlw.vue?vue&type=style&index=0&id=76dddf7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76dddf7a",
  null
  
)

export default component.exports